module.exports = __webpack_public_path__ + "static/img/BenHarvey.df0a2dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BenHarvey.jpg
// module id = XljK
// module chunks = 0